const tr = {
  reportsMercadoPago: {
    attributes: {
      person_name: 'Titular',
      product_description: 'Produto',
      cpf: 'CPF',
      value: 'Valor (R$)',
      payment_type: 'Tipo',
      status: 'Status',
      installments: 'Parcelas',
      reports: 'Relatório Mercado Pago',
      reports_description:
        'Relatório de vendas realizada através da integração com Mercado Pago',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      notUsedDaysAfter: 'Não utilizado dentro de 7 dias',
      notRenewedAfterAcquire: 'Não renovados pós-compra',
    },
    defSingular: 'Relatório Mercado Pago',
  },
};

export default tr;
